export const users = [
  {
    id: 1,
    name: "Christal M. Jackson",
    tags: "#leadership #philanthropy #socialimpact #entrepreneurs and #entrepreneurship",
    title: "Impact and Equity Architect",
    bannerImg: "./images/banner1.jpg",
    userImg: "./images/user1.jpg",
  },
  {
    id: 2,
    name: "Chef JJ johnson",
    tags: " #chef #cooking #culture #hospitality and #restaurants",
    title: "Founder At Field Trip",
    bannerImg: "/images/banner4.jpg",
    userImg: "/images/user4.jpg",
  },

  {
    id: 3,
    name: "Roger W. Ferguson, Jr",
    title: "Former President and Ceo at Tiaa",
    tags: "#education #leadership #federalreserve #financeandeconomy and #diversityinclusion",
    bannerImg: "/images/banner6.jpg",
    userImg: "/images/user6.jpg",
  },
  {
    id: 4,
    name: "Karamo Brown",
    tags: "",
    title: "Member’s occupation Culture Expert QUEER EYE at Netflix",
    bannerImg: "/images/banner2.jpg",
    userImg: "/images/user2.jpg",
  },
  {
    id: 5,
    name: "Laura Morgan Roberts",
    title:
      "Organizational Psychologist / Author / Keynote Speaker / Professor / Consultant / Advisor / Architect of Alignment",
    tags: "#thriving #alignment #racialequity #womenleading and #diversityequityinclusion",
    bannerImg: "/images/banner5.jpg",
    userImg: "/images/user5.jpg",
  },

  {
    id: 6,
    name: "Tiffany dufu",
    tags: "",
    title: "Founder && Ceo The cru",
    bannerImg: "/images/banner3.jpg",
    userImg: "/images/user3.jpg",
  },
];
